import React from 'react';
import styles from './AssignClinicToChain.module.scss';
import ClinicNumberExplained from "../../assets/examples/clinic-number.png"
import { $t } from "../../helpers/translator";
import api from "../../helpers/api";
import Modal from "../miscellaneous/Modal/Modal";
import Loader from "../miscellaneous/Loader/Loader";
import HasPermission from 'helpers/permissions/HasPermission';

class AssignClinicToChain extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAssignClinicModal: false,
            assignClinic: {
                clinicNumber: '',
                error: '',
                serverError: ''
            },
            assignmentError: ''
        };
    }

    async componentDidMount() {

    }


    closeModals() {
        this.setState({
            showAssignClinicModal: false,
            assignmentError: '',
            assignClinic: {
                clinicNumber: '',
                error: '',
                serverError: ''
            },
        })
    }

    async assignClinicClickHandler() {
        let value = this.state.assignClinic.clinicNumber.trim();
        let error = '';

        if (value.length !== 9) {
            error = $t('validation.general.length', [ '9' ])
        }
        if (!(/^\d+$/.test(value))) {
            error = $t('validation.general.numeric')
        }
        if (value === '') {
            error = $t('validation.general.required')
        }

        let assignClinic = { ...this.state.assignClinic }
        assignClinic.error = error;
        this.setState({ assignClinic: assignClinic }, async () => {
            if (error) {
                return;
            }

            this.setState({ assignmentLoading: true }, async () => {
                try {
                    let res = await api.post('/clinic/request/add', { clinic_number: value })
                    // console.log(res)
                    if (res.status !== 200) {
                        this.setState({ assignmentError: res.errorText ? res.errorText : $t('validation.more.generalError') })
                        return;
                    }
                    // console.log('res', res, res.error)
                    this.closeModals();

                    this.props.onchange();
                } catch (e) {
                    console.error('err assign', e);
                }
            })
        })
    }

    fieldChangeHandler(e) {
        let assignClinic = { ...this.state.assignClinic };
        assignClinic.clinicNumber = e.target.value;
        this.setState({ assignClinic: assignClinic, assignmentError: '' });
    }

    renderAssignClinic() {
        return (
            <>
                { this.state.showAssignClinicModal && <div>
                    <div className={ `${styles[ 'row' ]}` }>
                        <div className={ `${styles[ 'rodal-header' ]}` }>{ $t('global.account.addClinic') }</div>
                    </div>
                    <div style={ { margin: '10px 0;' } }>
                        <img src={ ClinicNumberExplained } style={ { border: '1px solid gray' } }
                            alt={ 'Where to find the clinic number' } />
                        <div style={ { fontSize: '80%' } }>{ $t('global.account.clinicNumberLocation') }</div>
                    </div>
                    <div className={ `${styles[ 'row-form' ]}` }>
                        <div>{ $t('global.account.clinicNumber') }</div>
                        <div className={ `${styles[ 'input-container' ]}` }>
                            <input name="clinicNumber"
                                id='clinicNumberInput'
                                className={ 'alma-input' }
                                type="text"
                                value={ this.state.assignClinic.clinicNumber }
                                onChange={ (e) => this.fieldChangeHandler(e) } />
                        </div>
                    </div>
                    <div className={ `${styles[ 'error-text' ]}` }>{ this.state.assignClinic.error }</div>

                    { this.state.loading ?
                        <Loader />
                        :
                        <div className={ `${styles[ 'row' ]} ${styles[ 'flex-end' ]}` }>
                            <div className={ 'alma-button' }
                                onClick={ () => this.assignClinicClickHandler() }>{ $t('global.account.assignClinic') }
                            </div>
                        </div>
                    }
                    <div className={ `${styles[ 'error-text' ]}` }>{ this.state.assignmentError }</div>
                </div> }

            </>
        )
    }


    render() {
        return (
            <div>
                <HasPermission permission="clinic.create">
                    <div className={ `${styles[ 'flex-end' ]}` }>
                        <div id="assignClinic" className={ 'alma-button' }
                            style={ { marginTop: '15px;' } }
                            onClick={ () => this.setState({ showAssignClinicModal: true }) }>
                            { $t('global.account.addClinic') }
                        </div>
                    </div>

                    <Modal content={ this.renderAssignClinic() }
                        onClose={ this.closeModals.bind(this) }
                        visible={ this.state.showAssignClinicModal } />
                </HasPermission>
            </div>
        );
    }

}

export default AssignClinicToChain;
